<div class="axle">
    <div id="left-wheel">
    </div>
    <div class="tire-left" [ngStyle]="{'background-color': tires()[0]?.color}">
        <img src="./assets/images/ic_tire.png" height="76" width="26" (click)="changeTireClassification(0)">
    </div>
    @if (quantityTires() === 4) {
        <div class="tire-left second" [ngStyle]="{'background-color': tires()[1]?.color}">
            @if (isActiveAxle() && !isReportItem()) {
                <i class="material-icons pointer" (click)="addOrRemoveTires()">remove_circle_outline</i>
            }
            @if (!isActiveAxle()) {
                <img src="./assets/images/ic_tire_empty.png" height="76" width="26" (click)="addOrRemoveTires()">
            }
            @if (isActiveAxle()) {
                <img src="./assets/images/ic_tire.png" height="76" width="26" (click)="changeTireClassification(1)">
            }
        </div>
    }
    <div id="right-wheel">
    </div>
    <div class="tire-right" [ngStyle]="{'background-color': tires()[!isActiveAxle() ? 1 : 2]?.color}">
        <img src="./assets/images/ic_tire.png" height="76" width="26" (click)="changeTireClassification(2)">
    </div>
    @if (quantityTires() === 4) {
        <div class="tire-right second" [ngStyle]="{'background-color': tires()[3]?.color}">
            @if (isActiveAxle() && !isReportItem()) {
                <i class="material-icons pointer" (click)="addOrRemoveTires()">remove_circle_outline</i>
            }
            @if (!isActiveAxle()) {
                <img src="./assets/images/ic_tire_empty.png" height="76" width="26" (click)="addOrRemoveTires()">
            }
            @if (isActiveAxle()) {
                <img src="./assets/images/ic_tire.png" height="76" width="26" (click)="changeTireClassification(3)">
            }
        </div>
    }
    <div class="bar">
    </div>
    <div class="message">
        <p>{{ message() }}</p>
    </div>
</div>
